import type { ChakraProps } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/react';

export type Variants = 'subtle';

export function useLinkStyles(commonProps: ChakraProps, variant?: Variants) {
  const subtleLinkBg = useColorModeValue('#8a8989', '#8a8989');

  switch (variant) {
    case 'subtle': {
      return {
        ...commonProps,
        px: '10px',
        py: '6px',
        bgColor: subtleLinkBg,
        borderRadius: 'base',
      };
    }

    default:{
      return commonProps;
    }
  }
}
